import { TableContentContainer } from '../../TableContentContainer';
import { DesktopTableContent } from './DesktopTableContent';

const DesktopTBody = ({ rows, isLoading, emptyText, hasStickyHeader }) => {
  return (
    <TableContentContainer rows={rows} isLoading={isLoading} emptyText={emptyText}>
      <DesktopTableContent rows={rows} hasStickyHeader={hasStickyHeader} />
    </TableContentContainer>
  );
};

export default DesktopTBody;
